import styled from 'styled-components/macro';

import media from '../../styles/media';
import { fontSize } from '../../styles/mixins';

import Icon from '../Icon';

export const ModalContainer = styled.div`
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  display: flex;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 99;
`;

export const Modal = styled.div`
  background-color: ${({ theme }) => theme.modalBgColor};
  z-index: 99;
  display: flex;
  flex-direction: column;
  position: sticky;
  margin: auto;
  width: 100%;
  height: 100%;
  padding: 20px 30px;
  border-top: 3px solid ${({ theme }) => theme.primaryColor};
  overflow-y: auto;

  ${media.desktop`
    width: 768px;
    height: unset;
  `};
`;

export const ModalContent = styled.div`
  margin-top: 30px;
  flex-grow: 1;
`;

export const CloseIcon = styled(Icon)`
  color: ${({ theme }) => theme.primaryColor};
  ${fontSize(20)};
  position: absolute;
  right: 20px;
  top: 20px;

  &:hover {
    color: ${({ theme }) => theme.hoverColor};
  }
`;

export const ModalFooter = styled.footer`
  display: flex;
  flex-direction: column;
  margin-top: 30px;

  ${media.desktop`
    flex-direction: row;
    justify-content: center;
    margin-top: 50px;
  `};

  .modalButton {
    width: 100%;
    margin-bottom: 20px;

    ${media.desktop`
      width: 40%;
      margin-right: 20px;

      &:last-child {
        margin-right: 0;
      }
    `};
  }
`;
